import gql from "graphql-tag";
import className from "classnames/bind";
import { GenericEmbedFragment } from "@graphqlTypes";
import { Container } from "@components";

import styles from "./GenericEmbed.module.scss";
const cx = className.bind(styles);

export default function GenericEmbed({ url, label }: GenericEmbedFragment) {
  return (
    <section className={cx(["generic-embed"])}>
      <Container>
        <div className={cx("embed-responsive")}>
          <iframe
            title={label || "Embedded content"}
            src={url}
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      </Container>
    </section>
  );
}

GenericEmbed.fragments = {
  entry: gql`
    fragment GenericEmbed on FlexiblePageContentContentGenericEmbedLayout {
      label
      url
    }
  `,
};
